import React, { Component } from "react";
import { toFixed, GET, loading, Navbar, params } from "../../components/CustomComponent.js";
import LOGOLARGE from "../../assets/images/logo512.png";
import Footer from "../../components/Footer.js";

const count_per_page = 48;

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_category: global.category.sort(() => Math.random() - 0.5).slice(0, 4),
      filter_search: params("keyword") || "",
      filter_category: params("category") ? global.category.find(e => e.name === params("category"))?.category_name || "" : "",
      page: params("category") || params("keyword") ? 1 : Math.floor(Math.random() * 10) + 1,
      
      visitedPages: [],
      count: Infinity, // กำหนดค่าเริ่มต้นเพื่อให้รอบแรกทำงานได้
      isLoading: false, // ใช้เช็คสถานะการโหลด
    };
  }

  componentDidMount() {
    const { page } = this.state;
    // เพิ่ม Event Listener จับการเลื่อนหน้าจอ
    window.addEventListener("scroll", this.handleScroll);
    this.Get(page);
  }

  componentWillUnmount() {
    // ลบ Event Listener ออกเมื่อ Component ถูกทำลาย ป้องกัน Memory Leak
    window.removeEventListener("scroll", this.handleScroll);
  }

  // ฟังก์ชันดักจับการเลื่อนจอ
  handleScroll = () => {
    const { isLoading, page, count, filter_category, filter_search } = this.state;
    
    // ถ้ากำลังโหลดอยู่ หรือโหลดถึงหน้าสุดท้ายแล้ว ให้หยุดทำงาน
    if (isLoading || page >= count) return;

    // คำนวณความสูง: ถ้าเลื่อนมาจนเหลือระยะห่างจากขอบล่างน้อยกว่า 200px ให้โหลดหน้าถัดไป
    if (
      window.innerHeight + document.documentElement.scrollTop + 200 >= 
      document.documentElement.scrollHeight
    ) {
      let targetPage = page + 1;
      if(!filter_category && !filter_search){

        targetPage = this.getRandomPage();
      }

      this.Get(targetPage);
    }
  };

  getRandomPage = () => {
    const { visitedPages, count } = this.state;
    // กำหนดเพดานการสุ่ม ถ้ายังไม่รู้จำนวนหน้าทั้งหมดจาก API ให้สุ่มในช่วง 1-50 ไปก่อน
    const maxPage = count === Infinity ? 50 : count;
    
    let availablePages = [];
    for (let i = 1; i <= maxPage; i++) {
      if (!visitedPages.includes(i)) {
        availablePages.push(i);
      }
    }

    if (availablePages.length === 0) return null; // หมดหน้าให้สุ่มแล้ว

    const randomIndex = Math.floor(Math.random() * availablePages.length);
    return availablePages[randomIndex];
  };

  Get = async (targetPage = 1) => {
    const { data, filter_search, filter_category } = this.state;
    
    // ป้องกันการยิง API ซ้อนกัน
    if (this.state.isLoading) return;
    this.setState({ isLoading: true });

    let _data = [], count = this.state.count;
    try {
      let [result] = await Promise.all([
        GET("v1/market/products", { page: targetPage, page_size: count_per_page, data_search: ((filter_category ? filter_category + " " : "") + filter_search).trim() }),
      ]);

      if (result?.status) {
        _data = result.data || [];
        count = Number((result.pagination?.count / count_per_page).toFixed(0));
      } else {
        localStorage.clear();
        alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
      }

      // จัดการ Data (เหมือนโค้ดเดิมของคุณ)
      const processedData = _data
        .filter(e => !filter_search || e.product_name.toLowerCase().includes(filter_search.toLowerCase()))
        .sort(() => Math.random() - 0.5)
        .filter(e => e.product_image);

      this.setState({
        data: targetPage === 1 ? processedData : [...data, ...processedData], // ถ้าหน้า 1 ให้ทับข้อมูลเดิม
        count,
        page: targetPage,
        isLoading: false // ปิดสถานะโหลดเมื่อเสร็จสิ้น
      });
    } catch (error) {
      console.error(error);
      this.setState({ isLoading: false });
    }
  };

  // ฟังก์ชันวาด Skeleton Card
  renderSkeleton() {
    // สร้าง Dummy Array ไว้ render skeleton 12 ชิ้น (ตามขนาดการแสดงผลที่เหมาะสม)
    return Array.from({ length: 12 }).map((_, index) => (
      <div key={`skeleton-${index}`} className="col-6 col-sm-4 col-md-3 col-xl-2 px-1 mb-2">
        <div className="p-1 bg-light product" style={{ opacity: 0.7 }}>
          <div 
            className="bg-secondary" 
            style={{ inset: 0, margin: "auto", height: "100%", aspectRatio: "1 / 1", opacity: 0.2 }}
          ></div>
          <div className="p-2 placeholder-glow">
            {/* เลียนแบบข้อความชื่อสินค้า */}
            <div style={{ height: "14px", backgroundColor: "#e0e0e0", marginBottom: "4px", borderRadius: "2px", width: "100%" }}></div>
            <div style={{ height: "14px", backgroundColor: "#e0e0e0", marginBottom: "12px", borderRadius: "2px", width: "70%" }}></div>
            
            {/* เลียนแบบราคา */}
            <div style={{ height: "20px", backgroundColor: "#d0d0d0", marginBottom: "12px", borderRadius: "2px", width: "50%" }}></div>
            
            {/* เลียนแบบยอดขาย/ดาว */}
            <div className="d-flex justify-content-between">
              <div style={{ height: "12px", backgroundColor: "#e0e0e0", borderRadius: "2px", width: "40%" }}></div>
              <div style={{ height: "12px", backgroundColor: "#e0e0e0", borderRadius: "2px", width: "30%" }}></div>
            </div>
          </div>
        </div>
      </div>
    ));
  }

  render() {
    const { data, data_category, filter_search, isLoading } = this.state;
    
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        {/* SECTION 1 - ค้นหา */}
        <div className="w-100 bg-orange p-4 pb-2">
          <div className="container">
            <div className="d-flex mb-1 position-relative">
              <input 
                className="form-control hpx-50" 
                placeholder="ค้นหาสินค้า..." 
                onChange={e => this.setState({ filter_search: e.target.value })} 
                value={filter_search} 
                onKeyUp={e => {
                  if(e.key === "Enter"){
                    this.setState({ data: [], page: 1}, () => this.Get(1))
                  }
                }}
              />
              <button 
                className="btn bg-orange fw-bold text-white px-4 ms-2 position-absolute" 
                style={{height:42, right: 4, top: 4}}
                onClick={() => this.setState({ data: [], page: 1}, () => this.Get(1))}
              >
                <span className="icon">{"\uf002"}</span>
              </button> 
            </div>
            <div>
              {data_category.map((item, index) => (
                <button 
                  key={index} 
                  className="btn btn-link text-light text-decoration-none" 
                  onClick={() => window.location.href = `/product?category=${item.name}`}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* SECTION 2 - รายการสินค้า */}
        <div className="w-100 px-1 py-2 p-md-4 min-vh-100">
          <div className="container">
            {params("category") && (
              <h4 className="mb-4 d-flex align-items-center">หมวดหมู่: {params("category")} <a href="/main" className="wpx-20 hpx-20 rounded-circle d-flex align-items-center justify-content-center bg-danger-light icon text-danger text-14 mt-1 ms-2 pointer border-1 border-danger text-decoration-none">{"\uf00d"}</a></h4>
            )}
            <div className="row mb-4">
              
              {/* แสดงข้อมูลสินค้าที่มีอยู่ */}
              {data.map((item, index) => (
                <a 
                  key={item.uid || index} 
                  className="col-6 col-sm-4 col-md-3 col-xl-2 px-1 mb-2 text-decoration-none text-dark" 
                  href = {`/product-detail?pd=${item.uid}`}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="p-1 bg-light product">
                    <div className="bg-secondary-light" style={{ inset: 0, margin: "auto", height: "100%", aspectRatio: "1 / 1", pointerEvents: "none", position: "relative" }}>
                      <img 
                        alt="Logo" 
                        src={item.product_image || LOGOLARGE} 
                        height={"100%"} 
                        width={"100%"} 
                        style={{ objectFit: "cover" }} 
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = LOGOLARGE;
                        }}
                      />
                    </div>
                    <div className="p-2">
                      <div className="overflow-hidden" style={{ lineHeight: 1.2, height: 36 }}>{item.product_name}</div>
                      <h5 className="fw-bold">฿{toFixed(Number(item.price), 2)}</h5>
                      <div className="d-flex justify-content-between">
                        <small className="text-secondary">ขายได้ {item.sold} ชิ้น</small>
                      </div>
                    </div>
                  </div>
                </a>
              ))}

              {/* แสดง Skeleton ตอนที่กำลังโหลดข้อมูล (ต่อท้ายรายการเดิม) */}
              {isLoading && this.renderSkeleton()}

            </div>
            
            {/* นำปุ่ม "เพิ่มเติม" ออกไปแล้ว เพราะใช้เลื่อนหน้าจอแทน */}
          </div>
        </div>
        
        <Footer />
      </div>
    );
  }
}